import { render } from "./CollaboratorCard.vue?vue&type=template&id=3bca3688&scoped=true"
import script from "./CollaboratorCard.vue?vue&type=script&lang=js"
export * from "./CollaboratorCard.vue?vue&type=script&lang=js"

import "./CollaboratorCard.vue?vue&type=style&index=0&id=3bca3688&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bca3688"]])

export default __exports__